import { AgGridReact } from "ag-grid-react";
import { useEffect ,useMemo,useRef } from "react";
import { useState } from "react";
import { sbaAxios } from "../../../../utils/sbaAxios";
import {
  getBillingContactsAPI,
  getBillingFeeDefintionAPI,
  getBillingFeeTypesAPI,
  getBillingGetExistingClientsAPI,
  getContacts,
  insertOrUpdateBillingAPI,
  getAllActivePortFolioIds,
  getPortfolioExistingAsset,
  getClientBillingMapping,
  getAssetShareClassddl,
  getAssetShareClassFeedetails,
  billingInsertClntBillMappingAPI,
  getClientBillingFee,
  getClientMgmtFee,
  insertorupdateFee,
  getIsBillableAPI,
  insertOrUpdateFeeDefinition
} from "../../../../../config/apiConfig";
import { SBAComboBox } from "../../../../UiComponents/SBADropDown";
import { getTaxEntityListAction } from "../../../../actions/investorAccounts";
import { useDispatch, useSelector } from "react-redux";
import { SBNotify } from "../../../../utils/sbNotify";
import { CurrencyFormat } from "../../../../utils/currencyFormattter";
import { SBADrawer } from "../../../../UiComponents/SBADrawer";
import { SBADropDown } from "../../../../UiComponents/SBADropDown";

import {StatementMap} from "../SetuptTab/StatementMap";
import moment from "moment";
import { Invoice } from "./Invoice";

export const CalculationTab = () => {
  const [selectedTab, setSelectedTab] = useState(1);
  return <>
    <div className="p-2 d-flex">
      <div className="button-container verticalTabButton" >
        <button
          className={`non-gappable-button ${selectedTab === 1 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={() => { setSelectedTab(1) }}
        >
          Billing
        </button>

        <button
          className={`non-gappable-button ${selectedTab === 2 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={() => { setSelectedTab(2) }}

        >
          Stmt Map
        </button>
        <button
          className={`non-gappable-button ${selectedTab === 3 ? "selected-non-gappable-button" : "non-gappable-button"}`}
          onClick={() => { setSelectedTab(3) }}

        >
          Invoices
        </button>


      </div>
      <div className='p-2 flex-grow-1'>
        {selectedTab === 1 && <>  <Calculation />  </>}
        {selectedTab === 2 && <> <StatementMap></StatementMap></>}
        {selectedTab === 3 && <> <Invoice/>  </>}
        {/* {selectedTab === 4 && <>  Revenue /  </>} */}
      </div>
    </div>
  </>
};


const Calculation = () => {

  const dispatch = useDispatch();

  const Gstate = useSelector(state => state);
  const taxEntityList = Gstate.investorAccounts.taxEntityList;

  const [existingClientBilling, setExistingClientBilling] = useState([]);
  const [showEditor, setShowEditor] = useState(false);
  const [selectedClientBilling, setSelectedClientBilling] = useState(null);
  const [contactList, setContactList] = useState([]);
  const [feeTypeList, setFeeTypeList] = useState([]);

  useEffect(() => {
    getExistingClientBilling();
    dispatch(getTaxEntityListAction());
  }, []);
  const getExistingClientBilling = () => {
    try {
      sbaAxios({ url: getBillingGetExistingClientsAPI }).then(res => {
        setExistingClientBilling(res);
      }).catch(er => {
        setExistingClientBilling([]);
      });
    } catch (error) {

    }
  };
  const fetchAccountMapping = async (billingID) => {
    try {
      const dat = await sbaAxios({
        url: getClientBillingMapping + `/${billingID}`
      })
      return dat;
    }
    catch (e) {
      return [];
    }
  }
  const fetchFeeMapping = async (billingID) => {
    try {
      const dat = await sbaAxios({
        url: getClientBillingFee + `${billingID}`
      })
      return dat;
    }
    catch (e) {
      return [];
    }
  }
  const fetchMgmtMapping = async (billingID) => {
    try {
      const dat = await sbaAxios({
        url: getClientMgmtFee,
        params:{
          clientBillingId:billingID
        }
      })
      return dat;
    }
    catch (e) {
      return [];
    }
  }
  const ActionColumnRenderer = (e) => {
    try {
      return <div className="actions-cell">
        <i className="fas fa-edit" style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={() => { editSelectedClientBilling(e.data) }} ></i>
        {/* <i className="fa fa-trash" style={{ color: "red", margin: "0 8px", cursor: "pointer" }} ></i> */}
      </div>
    } catch (error) {

    }
  }
  const columnDefs = [
    { headerName: "Billing Name", field: "ClientBillingName" },
    { headerName: "Contact", field: "ContactName" },
    { headerName: "Description", field: "ClientBillingDesc" },
    // { headerName: "Created Date", field: "ModifiedDate" ,floatingFilter: false ,cellDataType:"dateString"},
    { headerName: "Created By", field: "ModifiedBy", floatingFilter: false },
    { headerName: "Action", field: "", cellRenderer: ActionColumnRenderer, floatingFilter: false, maxWidth: 100 },
  ];
  const defaultColumnDef = {
    flex: 1,
    minWidth: 100,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    sortable: true,
    filter: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    autoHeaderHeight: true
  };
  const setContactListFromAPI = async () => {
    try {
      const res = await sbaAxios({ url: getBillingContactsAPI });
      return res
    } catch (error) {
      console.log(error, 'Error while fetching contact list data');
      return [];
    }
  }
  const setFeeListFromAPI = async () => {
    try {
      const res = await sbaAxios({ url: getBillingFeeTypesAPI });
      return res
    } catch (error) {
      console.log(error, 'Error while fetching Feetype list data');
      return [];
    }
  }
  const addNewClientBilling = async () => {
    try {
      const Contactlist = await setContactListFromAPI();
      const feelist = await setFeeListFromAPI();
      setFeeTypeList(feelist);
      setContactList(Contactlist);
      setSelectedClientBilling(null);
      setShowEditor(true);
    } catch (error) {

    }
  };
  const editSelectedClientBilling = async (data) => {
    try {
      const Contactlist = await setContactListFromAPI();
      const feelist = await setFeeListFromAPI();
      const accountItems = await fetchAccountMapping(data?.ClientBillingId);
      const feeItem=await fetchFeeMapping(data?.ClientBillingId);
      const mgmtFeeItem=await fetchMgmtMapping(data?.ClientBillingId);
      setFeeTypeList(feelist);
      setContactList(Contactlist);
      data.AccountList = accountItems;
      data.FeeItem=feeItem;
      data.ManagementFee=mgmtFeeItem;
      setSelectedClientBilling(data);
      setShowEditor(true);
    } catch (error) {

    }
  };
  const saveClientBilling = (saveData) => {
    try {
      // sbaAxios({ url: insertOrUpdateBillingAPI, data: saveData, method: 'post' }).then(res => {
      //   if (res > 0) {
      //     if (saveData.ClientBillingId > 0)
      //       SBNotify({ Msg: "Client Billing has been Created Successfully" });
      //     else
      //       SBNotify({ Msg: "Client Billing has been Updated Successfully" });
      //   }
      //   else if (res == -3) {
      //     SBNotify({ Msg: "Client Billing name already exist", type: 'error' });
      //   }
      //   setShowEditor(false);
      // }).catch(error => {
      //   console.log('error updating Client billing Data' + error);
      // });
      getExistingClientBilling();
    } catch (error) {

    }
  };
  
  return <>
    {!showEditor && <>  <div className="d-flex">
      <button className="p-sm-btn ms-auto" onClick={() => { addNewClientBilling() }}> <i className="fa-plus fa-solid" onClick={() => { addNewClientBilling() }}></i>Add</button>
    </div>
      <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
        <AgGridReact columnDefs={columnDefs} rowData={existingClientBilling} defaultColDef={defaultColumnDef}></AgGridReact>
      </div></>}
    {showEditor && <>
      <EditORAddNewClientBilling SaveClientBillingData={saveClientBilling} clientBillingData={selectedClientBilling} setShowEditor={setShowEditor} accountList={taxEntityList} contactList={contactList} feeTypeList={feeTypeList} />
    </>}
  </>
};


const EditORAddNewClientBilling = ({ clientBillingData, SaveClientBillingData, setShowEditor, contactList, accountList, feeTypeList }) => {
  const [billingData, setBillingData] = useState(clientBillingData);
  const [feeDefintionData, setFeeDefintionData] = useState([]);
  const [accountDrawer, setAccountDrawer] = useState(false);
  const [showAddDrawer, setShowAddDrawer] = useState(false);
  const [accRowData, setAccRowData] = useState([]);
  const [SBAFeeRowData, setSBAFeeRowData] = useState([]);
  const [showEditDrawer, setShowEditDrawer] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);


  const [addNewFee,setAddNewFee]=useState(false);
  const [addNewFeeDetails, setAddNewFeeDetails] = useState(
    {
      // ClientFeeMappingId: 0,
      // ClientBillingId: 0,
      // ClientBillingName: "",
      // FeeTypeId: 6,
      // FeeSubTypeId: 7,
      // FeeSubType: "",
      // FeeDefinitionId: 0,
      // FeeDefinition: "",
      // TierLevel: 0,
      // MinAumRequired: 0,
      // MaxAumRequired: 0,
      // MinThreshold: 0,
      // MaxThreshold: 0,
      // FeeValType: 1,
      // FeeValue: 0,
      // MinFeeValue: 0,
      // MaxFeeValue: 0
    });
  const feeStructureRef=useRef();

  const [selectedFeeType,setSelectedFeeType]=useState(null);
  useEffect(() => {
    if (clientBillingData) {
      setBillingData(clientBillingData);
      setAccRowData(clientBillingData?.AccountList || []);
      setFeeDefintionData(clientBillingData?.FeeItem.map(item=>({...item,FeeValueTypeId:item.FeeValType})) || []);
      const formattedMgmtFee=clientBillingData?.ManagementFee?.map((item,index)=>( {
        "rowId": index,
        "PortfolioName": item.PortfolioName,
        "AssetName": item.AssetName,
        "ShareClassName": item.ShareClassName,
        "ManagementFee": (item?.FeeValue || 0),
        "CreatedDate": item.CreatedDate,
        "CreatedBy": item.CreatedBy,
        "selectedPortfolio": {
            "ActivePortfolioId": item.PortfolioId,
            "ActivePortfolioName": item.PortfolioName
        },
        "selectedAsset": {
            "AssetId": item.AssetId,
            "AssetName": item.AssetName,
            "AssetType": "Stock",
            "Type": "Asset",
            "ChartOfAccount": "Fund",
            "AccountingMode": "Share Based",
            "StrategyName": "",
            "InitialAllocationDate": null,
            "StrategyId": 0,
            "IsShareBased": false,
            "IsMarketable": false
        },
        "selectedShareClass": {
            "ShareClassId": item.ShareClassId,
            "ShareClassName": item.ShareClassName,
            "IsDefaultClass": false
        }
    })) || [];
      setSBAFeeRowData(formattedMgmtFee);
    }
  }, [clientBillingData]);

  const handleDeleteClick = (params) => {
    setAccRowData(value => ([...value].filter(item => item.AccountId != params.data.AccountId)));
  };

  const ActionColumnRenderer = (e) => {
    try {
      return <div className="actions-cell">
        <i className="fa fa-trash" style={{ color: "red", margin: "0 8px", cursor: "pointer" }} onClick={() => handleDeleteClick(e)}></i>
      </div>
    } catch (error) {

    }
  };
  const percentageValueFormatter = (params) => {
    return `${(params.value * 100).toFixed(2)}%`;
  };
  const feeValueFormatter = (params) => {
    if(params.data.FeeValueTypeId==2 )
    return percentageValueFormatter(params);
    else 
    return CurrencyFormat(params.value, 2);

  };
  const CurrencyFormatter = (params) => {
    return CurrencyFormat(params.value, 2);
  };
  const columnDefs = [
    { headerName: "Account Name", field: "AccountName" },
    { headerName: "Action", field: "", cellRenderer: ActionColumnRenderer, floatingFilter: false, maxWidth: 100 },
  ];

  const feesColumnDef = useMemo(() => [
    { headerName: "Name", field: "FeeDefinition"},
    { headerName: "Fee Value", field: "FeeValue", valueFormatter: feeValueFormatter },
    { headerName: "Min Threshold", field: "MinThreshold", valueFormatter: CurrencyFormatter },
    { headerName: "Max Threshold", field: "MaxThreshold", valueFormatter: CurrencyFormatter },
    { headerName: "Min AumReq", field: "MinAumRequired", valueFormatter: CurrencyFormatter },
    { headerName: "Max AumReq", field: "MaxAumRequired", valueFormatter: CurrencyFormatter },
    { headerName: "Maximum Fee", field: "MaxFeeValue", valueFormatter: CurrencyFormatter },
  ], [selectedFeeType]); 

  const feesColumnDefForFixed = useMemo(() => [
    // { headerName: "", field: "" , cellRenderer:(props)=>{return <><input type="checkbox"/></>}  },
    {
      headerCheckboxSelection: true, 
      checkboxSelection: true,     
      width: 50,                   
    },
    { headerName: "Name", field: "FeeDefinition" ,editable: false},
    { headerName: "Fee Value", field: "FeeValue", valueFormatter: feeValueFormatter,  cellEditor: "agNumberCellEditor", editable: false },
    { headerName: "Min Threshold", field: "MinThreshold", valueFormatter: CurrencyFormatter },
    { headerName: "Max Threshold", field: "MaxThreshold", valueFormatter: CurrencyFormatter },
    { headerName: "Min AumReq", field: "MinAumRequired", valueFormatter: CurrencyFormatter },
    { headerName: "Max AumReq", field: "MaxAumRequired", valueFormatter: CurrencyFormatter },
    { headerName: "Maximum Fee", field: "MaxFeeValue", valueFormatter: CurrencyFormatter ,  cellEditor: "agNumberCellEditor",editable: false },
    { headerName: "", field: "", cellRenderer:(props)=>(<>
      <div>
            <i class="fas fa-edit text-success SBA_hand" onClick={()=>{updateFeeDefinition(props)}}></i>
        </div>
    </>) }
  ], [selectedFeeType]); 

  const updateFeeDefinition=(props)=>{
    const {data}=props;
    const saveData=  {
      ClientFeeMappingId: 0,
      ClientBillingId: 0,
      ClientBillingName: "",
      FeeTypeId: 6,
      FeeSubTypeId: 7,
      FeeSubType: "",
      FeeDefinitionId: data.FeeDefinitionId,
      FeeDefinition: data.FeeDefinition,
      TierLevel: data.TierLevel,
      MinAumRequired: data.MinAumRequired,
      MaxAumRequired: data.MaxAumRequired,
      MinThreshold: data.MinThreshold,
      MaxThreshold: data.MaxThreshold,
      FeeValType: data.FeeValueTypeId,
      FeeValue: data.FeeValueTypeId==2 ? data?.FeeValue*100 : data?.FeeValue,
      MinFeeValue: 0,
      MaxFeeValue: data.MaxFeeValue
    };
   setAddNewFeeDetails(saveData);
    // sbaAxios({url:insertOrUpdateFeeDefinition, method:"post",data:saveData}).then(async res=>{
    //   setAddNewFee(false);
    //   setAddNewFeeDetails({});
    //   SBNotify({ Msg: "Fee updated Successfully" });
    //   const feeDefinition = await setFeeDefinitionFromAPI(6);
    //   setFeeDefintionData(feeDefinition);
    // }).catch(error=>{

    // })
    setAddNewFee(true);
  }
  const onCellValueChanged = (params) => {
    const { field } = params.colDef;
    const updatedData = [...feeDefintionData];
    const rowIndex = params.node.rowIndex;
    const value=params.value;
    if (field === "FeeValue") {
      updatedData[rowIndex][field] = value/100;
    } else if (field === "MaxFeeValue") {
      updatedData[rowIndex][field] = value;
    }
    else{
      updatedData[rowIndex][field] = value;
    }
    setFeeDefintionData(updatedData);
  };
  const actionCellRenderer = (params) => {
    return (
      <div className="actions-cell">
        <i
          className="fas fa-edit"
          style={{ color: "#47A547", margin: "0 8px", cursor: "pointer" }}
          onClick={() => {
            setShowEditDrawer(true);
            setSelectedRowId(params.data.rowId);
          }}
        ></i>
        <i
          className="fa fa-trash"
          style={{ color: "red", margin: "0 8px", cursor: "pointer" }}
          onClick={() => {
            const updatedData = SBAFeeRowData.filter(row => row.rowId !== params.data.rowId)
            handleSBAFeedata(updatedData);
          }}
        ></i>
      </div>
    );
  };
  const SBAFeeColumnDef = [
    { headerName: "Portfolio Name", field: "PortfolioName" },
    { headerName: "Asset Name", field: "AssetName" },
    { headerName: "Share Class Name", field: "ShareClassName" },
    { headerName: "Management Fee", field: "ManagementFee"  },
    { headerName: "Created Date", field: "CreatedDate" ,valueFormatter:(e)=>(moment(e.value).format('MM/DD/YYYY'))},
    // { headerName: "Created By", field: "CreatedBy" },
    {
      headerName: "Action",
      field: "Action",
      cellRenderer: actionCellRenderer,
      sortable: false,
      filter: false
    }
  ];
  const defaultColumnDef = {
    flex: 1,
    minWidth: 100,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    sortable: true,
    autoHeaderHeight: true
  };

  const handleSBAFeedata = (data) => {
    setSBAFeeRowData(data);
  };
  const saveUpdatedData = () => {
    try {
      if (!billingData?.ClientBillingName) {
        SBNotify({ Msg: "Please Enter the Billing Name", type: "error" });
        return;
      }
      if (!billingData?.ContactId) {
        SBNotify({ Msg: "Please Select the Contact", type: "error" });
        return;
      }
      if (accRowData.length < 1) {
        SBNotify({ Msg: "Please Select Any Account", type: "error" });
        return;
      }
      const BillingDetails = {
        "contactId": billingData?.ContactId,
        "clientBillingName": billingData?.ClientBillingName,
        "modifiedBy": 0,
        "clientBillingDescr": billingData?.ClientBillingDesc,
        "clientBillingId": billingData?.ClientBillingId
      };
      const acountList =accRowData.map(item=>( {
        "clientBillingMappingId": 0,
        "clientBillingId": 0,
        "accountId": item.AccountId,
        "accountName": "string",
        "recordsType": "string"
      }));
      const selectedNodes = feeStructureRef?.current?.api?.getSelectedNodes();
      console.log(selectedNodes,'selectedNodes')
      const fixedIncomeFee = selectedNodes?.map((node) => node.data).map(item=>( {
        "clientFeeMappingId": item.ClientFeeMappingId,
        "clientBillingId": 0 ,
        "clientBillingName": "string",
        "feeTypeId": item.FeeTypeId,
        "feeSubTypeId": item.FeeSubTypeId,
        "feeSubType": "string",
        "feeDefinitionId": item.FeeDefinitionId,
        "feeDefinition": item.FeeDefinition,
        "tierLevel": item.TierLevel,
        "minAumRequired": item.MinAumRequired,
        "maxAumRequired": item.MaxAumRequired,
        "minThreshold": item.MinThreshold,
        "maxThreshold": item.MaxThreshold,
        "feeValType": item.FeeValueTypeId,
        "feeValue": item.FeeValue,
        "minFeeValue": item.MinFeeValue,
        "maxFeeValue": item.MaxFeeValue
      })) || [];
      console.log(feeDefintionData)
      const updatedFeeList=feeDefintionData.map(item=>( {
        "clientFeeMappingId": item.ClientFeeMappingId,
        "clientBillingId": 0 ,
        "clientBillingName": "string",
        "feeTypeId": item.FeeTypeId,
        "feeSubTypeId": item.FeeSubTypeId,
        "feeSubType": "string",
        "feeDefinitionId": item.FeeDefinitionId,
        "feeDefinition": item.FeeDefinition,
        "tierLevel": item.TierLevel,
        "minAumRequired": item.MinAumRequired,
        "maxAumRequired": item.MaxAumRequired,
        "minThreshold": item.MinThreshold,
        "maxThreshold": item.MaxThreshold,
        "feeValType": item.FeeValueTypeId,
        "feeValue": item.FeeValue,
        "minFeeValue": item.MinFeeValue,
        "maxFeeValue": item.MaxFeeValue
      }));
      const internalFee=SBAFeeRowData.map(item=>( {
        "clientMgmtFeeId": 0,
        "clientBillingId": 0,
        "clientBillingName": "",
        "accountId": 0,
        "portfolioId": item.selectedPortfolio.ActivePortfolioId,
        "portfolioName": "",
        "assetId": item.selectedAsset.AssetId,
        "assetName": "string",
        "shareClassId": 0,
        "shareClassName": "string",
        "feeValueTypeId": 0,
        "feeValue": parseFloat(item?.ManagementFee || 0),
        "isUpdateBillable": true,
        "createdDate": new Date().toISOString(),
        "createdBy": 0,
        "userId": 0,
        "modifiedBy": "string",
        "modifiedDate":new Date().toISOString(),
        "recordsType": "string"
      }))
      const saveData={
        AccountList:acountList,
        ClientFeeList:selectedFeeType?.FeeTypeId!=6 ?  updatedFeeList: fixedIncomeFee,
        BillingDetails:BillingDetails,
        InternalfeeList:internalFee
      };
      sbaAxios({ url: insertOrUpdateBillingAPI, data: saveData, method: 'post' }).then(res => {
        if (res > 0) {
          SBNotify({ Msg: "Client Billing has been Updated Successfully" });
        
          // sbaAxios({ url: billingInsertClntBillMappingAPI, method: 'post', data: acountList }).then(() => {
          //   if (saveData.ClientBillingId > 0)
          //     SBNotify({ Msg: "Client Billing has been Created Successfully" });
          //   else

          // })

        }
        else if (res == -3) {
          SBNotify({ Msg: "Client Billing name already exist", type: 'error' });
        }
        setShowEditor(false);
        SaveClientBillingData(null);
      }).catch(error => {
        console.log('error updating Client billing Data' + error);
      });
    } catch (error) {
      console.log(error, 'saving Client billing Data');
    }
  };
  const setFeeDefinitionFromAPI = async (feeTypeId) => {
    try {
      const res = await sbaAxios({ url: getBillingFeeDefintionAPI + feeTypeId });
      return res
    } catch (error) {
      console.log(error, 'Error while fetching Fee Defintion list data');
      return [];
    }
  }
  const handleFeeStructureChange = async (e) => {
    if (e.value) {
      const feeType = e.value;
      setSelectedFeeType(feeType);
      const feeDefinition = await setFeeDefinitionFromAPI(feeType.FeeTypeId);
      setFeeDefintionData(feeDefinition);
    }
  };
  const rowSelection = {
    mode: 'single'
  };
  const saveFeeDefinition=()=>{
   const saveData= {
      "clientFeeMappingId": 0,
      "clientBillingId": 0,
      "clientBillingName": "string",
      "feeTypeId": 6,
      "feeSubTypeId": addNewFeeDetails.FeeValType==2?7:6,
      "feeSubType": "string",
      "feeDefinitionId": addNewFeeDetails.FeeDefinitionId,
      "feeDefinition": addNewFeeDetails.FeeDefinition,
      "tierLevel": 0,
      "minAumRequired": addNewFeeDetails.MinAumRequired,
      "maxAumRequired": addNewFeeDetails.MaxAumRequired,
      "minThreshold": addNewFeeDetails.MinThreshold,
      "maxThreshold": addNewFeeDetails.MaxThreshold,
      "feeValType": addNewFeeDetails.FeeValType,
      "feeValue":addNewFeeDetails.FeeValType==2 ?  addNewFeeDetails.FeeValue/100 : addNewFeeDetails.FeeValue,
      "minFeeValue": 0,
      "maxFeeValue": addNewFeeDetails.MaxFeeValue
    }
    if(addNewFeeDetails.FeeDefinition && addNewFeeDetails.MinAumRequired>=0 && addNewFeeDetails.MaxAumRequired>=0 && addNewFeeDetails.MinThreshold >=0 && addNewFeeDetails.MaxThreshold >=0 && addNewFeeDetails.FeeValue >=0 && addNewFeeDetails.MaxFeeValue >=0 && addNewFeeDetails.FeeValType)
    {
      sbaAxios({url:insertOrUpdateFeeDefinition, method:"post",data:saveData}).then(async res=>{
        setAddNewFee(false);
        setAddNewFeeDetails({});
        SBNotify({ Msg: "Fee Added Successfully" });
        const feeDefinition = await setFeeDefinitionFromAPI(6);
        setFeeDefintionData(feeDefinition);
      }).catch(error=>{
  
      })
    }
    else 
    {
      SBNotify({Msg:"Please Fill All the Mandatory Fields" , type:"error"})
    }

  }
  return <div className="my-2 p-2">
    <div>
      {!clientBillingData && !clientBillingData?.ClientBillingId ? "New Billing" : "Edit Billing"}
    </div>
    <div className="d-flex">
      <button className="s-sm-btn ms-auto" onClick={() => setShowEditor(false)}>
        Cancel
      </button>
      <button className="p-sm-btn mx-2" onClick={() => { saveUpdatedData() }}>
        Save
      </button>
    </div>
    <div className="row">
      <div className="col-md-2">
        <div>
          <label className="mb-1 label">Billing Name</label>
          <div>

            <input type="text"
              className="w-100 form-control"
              value={billingData?.ClientBillingName}
              onChange={(e) => {
                setBillingData(val => ({ ...val, ClientBillingName: e.target.value }));
              }}
            />
          </div>
        </div>
      </div>
      <div className="col-md-2">
        <div>
          <label className="mb-1 label">Contact</label>
          <div>
            <SBAComboBox
              data={contactList}
              textField={"ContactName"}
              valueField={"ContactId"}
              value={{ ContactId: billingData?.ContactId, ContactName: billingData?.ContactName }}
              onChange={(e) => {
                if (e.value) {
                  setBillingData(val => ({ ...val, ContactName: e.value.ContactName, ContactId: e.value.ContactId }));
                }
              }}
            />
          </div>
        </div>
      </div>
      <div className="col-md-2">
        <div>
          <label className="mb-1 label">Billing Description</label>
          <div>
            <input type="text"
              className="w-100 form-control"
              value={billingData?.ClientBillingDesc}
              onChange={(e) => {
                setBillingData(val => ({ ...val, ClientBillingDesc: e.target.value }));
              }}
            />
          </div>
        </div>
      </div>
    </div>
    <div className="row my-4">
      <div className="col-md-4">
        <div className="d-flex justify-content-between">
          <label className="mb-1 label">Accounts</label>
          <button className="p-sm-btn" onClick={() => { setAccountDrawer(true); }}> <i className="fa-plus fa-solid"></i>Add New</button>
        </div>
        <div className="w-100 ag-theme-alpine m-1" style={{ height: '300px' }}>
          <AgGridReact columnDefs={columnDefs} rowData={accRowData} defaultColDef={defaultColumnDef}></AgGridReact>
        </div>
      </div>
      <div className="col-md-8">
        <div className="d-flex justify-content-between">
          <label className="mb-1 label">Fee Structure</label>
          <div className="d-flex">
            {selectedFeeType?.FeeTypeId == 6 &&
              <i class="fa-solid fa-plus text-success mx-2 row-items mb-2" onClick={() => { setAddNewFee(true); setAddNewFeeDetails({}) }}></i>
            }
          <SBAComboBox className="flex-fill"
            data={feeTypeList}
            textField={"FeeType"}
            valueField={"FeeTypeId"}
            onChange={(e) => { handleFeeStructureChange(e) }}
            value={selectedFeeType} 
          />
          </div>
          
        </div>
        <div className="w-100 ag-theme-alpine m-1" style={{ height: '300px' }}>
          { selectedFeeType?.FeeTypeId!=6? <>
            <AgGridReact columnDefs={feesColumnDef} suppressScrollOnNewData={true}   rowData={feeDefintionData} defaultColDef={defaultColumnDef}></AgGridReact>
           </> : <>
           <AgGridReact
              columnDefs={feesColumnDefForFixed}   
              rowSelection={rowSelection}
              rowData={feeDefintionData} 
              defaultColDef={defaultColumnDef}
              ref={feeStructureRef}
              suppressScrollOnNewData={true} 
              onCellValueChanged={onCellValueChanged}
              ></AgGridReact>           
           </>}
        </div>
      </div>
    </div>
    <div className="d-flex justify-content-between">
      <label className="label">Internal Fees</label>
      <button className="p-sm-btn" onClick={() => { setShowAddDrawer(true) }}>Add New</button>
    </div>
    <div className="row">
      <div className="w-100 ag-theme-alpine m-1" style={{ height: '300px' }}>
        <AgGridReact columnDefs={SBAFeeColumnDef} rowData={SBAFeeRowData} defaultColDef={defaultColumnDef}></AgGridReact>
      </div>
    </div>
    {accountDrawer && <EditORAddNewAccount open={accountDrawer} setOpen={setAccountDrawer} accountList={accountList} selectedAccountList={accRowData} setSelectedAccountList={setAccRowData} />}
    <AddInternalFee
      open={showAddDrawer}
      setOpen={setShowAddDrawer}
      handleSBAFeedata={handleSBAFeedata}
      rowData={SBAFeeRowData}
    >IsFee={false}
    </AddInternalFee>
    {showEditDrawer &&
      <EditInternalFee
        open={showEditDrawer}
        setOpen={setShowEditDrawer}
        handleSBAFeedata={handleSBAFeedata}
        rowData={SBAFeeRowData}
        rowId={selectedRowId}
        IsFee={false}
      ></EditInternalFee>}
      {addNewFee && <SBADrawer open={addNewFee} setOpen={setAddNewFee} style={{ width: "40vw" }} title= {addNewFeeDetails?.FeeDefinitionId>0 ? "Edit Fee":"Add New Fee"  } >
      <>
        <div className="my-4">
          <label className="label">
            Fee Definition Name
            <span className="mandatory">*</span>
          </label>
          <div>
            <input type="text"  className="form-control" value={addNewFeeDetails?.FeeDefinition} onChange={(e)=>{setAddNewFeeDetails(val=>({...val,FeeDefinition:e.target.value}))}}/ >
          </div>

        </div>
        <div className="my-4">
          <label className="label">
          Fee Value Type
            <span className="mandatory">*</span>
          </label>
          <div>
            <input type="Checkbox" className="mx-2"  checked={addNewFeeDetails?.FeeValType==1} onChange={(e)=>{setAddNewFeeDetails(val=>({...val,FeeValType:1}))}} / > Currency
            <input type="Checkbox" className="mx-2"  checked={addNewFeeDetails?.FeeValType==2} onChange={(e)=>{setAddNewFeeDetails(val=>({...val,FeeValType:2}))}} / > Percentage
          </div>
        </div>
        <div className="my-4">
          <label className="label">
          Fee Value
            <span className="mandatory">*</span>
          </label>
          <div>
            <input type="text"  className="form-control" value={addNewFeeDetails?.FeeValue} onChange={(e)=>{setAddNewFeeDetails(val=>({...val,FeeValue:e.target.value}))}}/ >
          </div>
        </div>
        <div className="my-4">
          <label className="label">
          Min Threshold
            <span className="mandatory">*</span>
          </label>
          <div>
            <input type="text"  className="form-control" value={addNewFeeDetails?.MinThreshold} onChange={(e)=>{setAddNewFeeDetails(val=>({...val,MinThreshold:e.target.value}))}}/ >
          </div>

        </div>
        <div className="my-4">
          <label className="label">
          Max Threshold
            <span className="mandatory">*</span>
          </label>
          <div>
            <input type="text"  className="form-control" value={addNewFeeDetails?.MaxThreshold} onChange={(e)=>{setAddNewFeeDetails(val=>({...val,MaxThreshold:e.target.value}))}}/ >
          </div>

        </div>
        <div className="my-4">
          <label className="label">
          Min Aum Required
            <span className="mandatory">*</span>
          </label>
          <div>
            <input type="text"  className="form-control" value={addNewFeeDetails?.MinAumRequired} onChange={(e)=>{setAddNewFeeDetails(val=>({...val,MinAumRequired:e.target.value}))}}/ >
          </div>

        </div>
        <div className="my-4">
          <label className="label">
          Max Aum Required
            <span className="mandatory">*</span>
          </label>
          <div>
            <input type="text"  className="form-control" value={addNewFeeDetails?.MaxAumRequired} onChange={(e)=>{setAddNewFeeDetails(val=>({...val,MaxAumRequired:e.target.value}))}}/ >
          </div>

        </div> <div className="my-4">
          <label className="label">
            Maximum Fee
            <span className="mandatory">*</span>
          </label>
          <div>
            <input type="text"  className="form-control" value={addNewFeeDetails?.MaxFeeValue} onChange={(e)=>{setAddNewFeeDetails(val=>({...val,MaxFeeValue:e.target.value}))}}/ >
          </div>

        </div>
        <div className="d-flex">
          <button className="s-sm-btn mx-2 ms-auto" onClick={()=>{
             setAddNewFee(false);
             setAddNewFeeDetails({});
          }}>Cancel</button>
          <button className="p-sm-btn mx-2" onClick={()=>{saveFeeDefinition()}}>Save</button>
        </div>
      </>

    </SBADrawer>}
  </div>
};
const EditORAddNewAccount = ({ open, setOpen, accountList, selectedAccountList, setSelectedAccountList }) => {
  const newAccountgrid= useRef();
  const ExistingAccountgrid= useRef();
  const [selectedAccount, setSelectedAccount] = useState([]);
  useEffect(() => {
    const formattedAccountList = selectedAccountList?.map(item => ({ TaxEntityName: item.AccountName, TaxEntityId: item.AccountId })) || [];
    setSelectedAccount(formattedAccountList);
  }, []);
  const availableAccountCOlDef = [
    { headerName: "Available Account", field: "TaxEntityName" },
  ];
  const selectedAccountCOlDef = [
    { headerName: "Selected Account", field: "TaxEntityName" },
  ];
  const addAccount=()=>{
    const newAcccount = ExistingAccountgrid.current.api.getSelectedRows();
    if(newAcccount.length>0){
      if (!selectedAccount.find(item => item.TaxEntityId == newAcccount[0].TaxEntityId))
        setSelectedAccount(value => ([...value, newAcccount[0]]))
    }
  }
  const removeAccount=()=>{
    const newAcccount = newAccountgrid.current.api.getSelectedRows();
    if(newAcccount.length>0){
      setSelectedAccount(value => (value.filter(item => item.TaxEntityId != newAcccount[0].TaxEntityId)))
        }
  }
  return <>
    <SBADrawer open={open} setOpen={setOpen} style={{ width: "70vw" }} title="Add New Account" >
      <div className="d-flex">
        <div className="w-50 ag-theme-alpine m-1" style={{ height: '300px' }}>
          <AgGridReact
            columnDefs={availableAccountCOlDef}
            rowData={accountList}
            defaultColDef={defaultColumnDef}
            onRowDoubleClicked={(e) => {
              if (!selectedAccount.find(item => item.TaxEntityId == e.data.TaxEntityId))
                setSelectedAccount(value => ([...value, e.data]))
            }}
            rowSelection={'single'}
            ref={ExistingAccountgrid}
          ></AgGridReact>
        </div>
        <div className='d-flex flex-column justify-content-center px-3'>
          <button className='p-sm-btn my-1' onClick={() => {addAccount() }}>
            <i class="fa-solid fa-arrow-right"></i>
          </button>
          <button className='p-sm-btn my-1' onClick={() => { removeAccount()}}>
            <i class="fa-solid fa-arrow-left"></i>
          </button>

        </div>
        <div className="w-50 ag-theme-alpine m-1" style={{ height: '300px' }}>
          <AgGridReact
            columnDefs={selectedAccountCOlDef}
            rowData={selectedAccount}
            defaultColDef={defaultColumnDef}
            ref={newAccountgrid}
            rowSelection={'single'}
            onRowDoubleClicked={(e) => { setSelectedAccount(value => (value.filter(item => item.TaxEntityId != e.data.TaxEntityId))) }}
          ></AgGridReact>
        </div>
      </div>
      <div className="d-flex my-3">
        <button className="s-sm-btn ms-auto" onClick={() => { setOpen(false) }}>Cancel</button>
        <button className="p-sm-btn mx-2" onClick={() => {
          setOpen(false);
          setSelectedAccountList(value => {
            return selectedAccount.map(item => ({
              "ClientBillingMappingId": 0,
              "ClientBillingId": 0,
              "AccountId": item.TaxEntityId,
              "AccountName": item.TaxEntityName,
              "RecordsType": "RecordsType"
            }))
          })
        }
        }
        >Save</button>
      </div>

    </SBADrawer>
  </>
};

export const AddInternalFee = ({ open, setOpen, handleSBAFeedata,handlefeedata, rowData,IsFee }) => {
  const [activePortfolios, setActivePortfolios] = useState([]);
  const [selectedPortfolio, setSelectedPortfolio] = useState(null);
  const [selectedPortfolioId, setSelectedPortfolioId] = useState(null);
  const [assets, setAssets] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [shareClass, setShareClass] = useState([]);
  const [selectedShareClass, setSelectedShareClass] = useState(null);
  const [selectedShareClassId, setSelectedShareClassId] = useState(null);
  const [mgmtFee, setMgmtFee] = useState(0.00);
  const [billingData,setbillingData]=useState([]);
  const [selectedClientbilling,setselectedClientbilling]=useState([]);
  const[IsBillable,setIsBillable]=useState(false);
  const resetData = () => {
    setAssets([]);
    setSelectedAsset(null);
    setSelectedAssetId(null);
    setShareClass([]);
    setSelectedShareClass(null);
    setSelectedShareClassId(null);
    setMgmtFee(0.00);
    setIsBillable(false);
  }
  useEffect(() => {
    if (selectedPortfolio) {
      resetData();
    }
  }, [selectedPortfolio])

  useEffect(() => {
    if (!open) {
      resetData();
      setActivePortfolios([]);
      setSelectedPortfolio(null);
      setSelectedPortfolioId(null)
    }
  }, [open]);

  useEffect(() => {
    getClientBilling();
    const fetchActivePortfolios = async () => {
      try {
        const list = await sbaAxios({
          url: getAllActivePortFolioIds
        })
        setActivePortfolios(list);
      }
      catch (e) {
        setActivePortfolios([])
      }
    }
    if (open) {
      fetchActivePortfolios();
    }
  }, [open]);

  useEffect(() => {
    const fetchAssets = async () => {
      try {
        const list = await sbaAxios({
          url: getPortfolioExistingAsset + `${selectedPortfolioId}`
        })
        setAssets(list);
      }
      catch (e) {
        setAssets([]);
      }
    }
    if (selectedPortfolioId) {
      fetchAssets();
    }
  }, [selectedPortfolioId])

  useEffect(() => {
    const fetchShareClass = async () => {
      try {
        const list = await sbaAxios({
          url: getAssetShareClassddl + `${selectedAssetId},${true}`
        })
        setShareClass(list)
        for (const item of list) {
          if (item.IsDefaultClass) {
            setSelectedShareClass(item);
            setSelectedShareClassId(item.ShareClassId);
            break;
          }
        }
      }
      catch (e) {
        setShareClass([]);
      }
    }
    if (selectedAssetId) {
      fetchShareClass();
    }
  }, [selectedAssetId]);

  useEffect(() => {
    const fetchShareClassFeeDetails = async () => {
      try {
        const list = await sbaAxios({
          url: getAssetShareClassFeedetails + `${selectedShareClassId}`
        })
        setMgmtFee(list[0].MgmtFee)
      }
      catch (e) {
        setMgmtFee(0.00);
      }
    }
    if (selectedShareClassId) {
      fetchShareClassFeeDetails();
    }
  }, [selectedShareClassId])
  
  const handleSelectedPortfolio = (e) => {
    setSelectedPortfolio(e.value)
    setSelectedPortfolioId(e.value.ActivePortfolioId)
  }

  const handleSelectedAsset = (e) => {
    setSelectedAsset(e.value);
    setSelectedAssetId(e.value.AssetId);
    setIsBillable(true);
  }

  const handleSelectedShareClass = (e) => {
    setSelectedShareClass(e.value);
    setSelectedShareClassId(e.value.ShareClassId);
  }

  const handleAddNew = () => {
    try {
      if(!selectedPortfolio?.ActivePortfolioName){
        SBNotify({ Msg: "Please Select A Portfolio" , type:"error" });
        return;
      }
      if(!selectedAsset?.AssetName)
      {
        SBNotify({ Msg: "Please Select A Asset" , type:"error"});
        return;
  
      }
      sbaAxios({url:getIsBillableAPI+`?AssetId=${selectedAsset.AssetId}&portfolioId=${selectedPortfolio.ActivePortfolioId}`})
      .then(res=>{
        if(res==1)
        {
          const data = {
            rowId: rowData.length + 1,
            PortfolioName: selectedPortfolio.ActivePortfolioName,
            AssetName: selectedAsset.AssetName,
            ShareClassName: selectedShareClass?.ShareClassName,
            ManagementFee: Number(mgmtFee.toFixed(2)),
            CreatedDate: new Date().toISOString(),
            CreatedBy: 0,
            selectedPortfolio: selectedPortfolio,
            selectedAsset: selectedAsset,
            selectedShareClass: selectedShareClass
          };
          handleSBAFeedata([...rowData, data]);
          setOpen(false);
        }
        else if(res==-1)
        {
          SBNotify({Msg:"Advised Billable Asset Flag not set" , type:"error"});
        }
        else if(res ==-2)
        {
          SBNotify({Msg:"Selected Portfolio and Asset Is Already Mapped in Internal Fee" , type:"error"});
        }
      })
      .catch(eror=>{
        console.log(eror+"Error Occured in getIsBillable")
      });
      
    } catch (error) {
      
    }
   
  }
  const getClientBilling = async () => {
    try {

        const response = await sbaAxios({
            url: `${getBillingGetExistingClientsAPI}`,
            method: 'get',
        });
        setbillingData(response)
       
    } catch (error) {
        console.error("Error fetching get billing data from API:", error);
    }
};
const getFees = async () => {
  try {

      const response = await sbaAxios({
          url: `${getClientMgmtFee}`,
          method: 'get',
      });
      handlefeedata(response);
     
  } catch (error) {
      console.error("Error fetching get billing data from API:", error);
  }
};
const clientBillingDDChng = (e) => 
{    
 if (e.value) {
     setselectedClientbilling({ClientBillingId:e.value.ClientBillingId,ClientBillingName:e.value.ClientBillingName});
 }
};
const saveInternalFee=()=>
{
  
  let ifsave = true;
  
  if (selectedClientbilling.length===0) {
    ifsave = false;
    SBNotify({ Msg: "Please Select Client Billing", type: "error" });
  }
  if (selectedPortfolio===null) {
    ifsave = false;
    SBNotify({ Msg: "Please Select Portfolio", type: "error" });
  }
  if (selectedAsset===null) {
    ifsave = false;
    SBNotify({ Msg: "Please Select Asset", type: "error" });
  }
 
  if (ifsave) {
    const data={
      "clientMgmtFeeId": 0,
      "clientBillingId": selectedClientbilling.ClientBillingId,
      "clientBillingName": "string",
      "accountId": 0,
      "portfolioId": selectedPortfolio.ActivePortfolioId,
      "portfolioName": "string",
      "assetId": selectedAsset.AssetId,
      "assetName": "string",
      "shareClassId": selectedShareClass===null?0:selectedShareClass.ShareClassId,
      "shareClassName": "string",
      "feeValueTypeId": 0,
      "feeValue": mgmtFee,
      "isUpdateBillable": true,
      "createdDate": "2024-10-07T09:07:59.002Z",
      "createdBy": 0,
      "userId": 0,
      "modifiedBy": "string",
      "modifiedDate": "2024-10-07T09:07:59.002Z",
      "recordsType": "string"
    }
    sbaAxios({
      url: `${insertorupdateFee}`,
      method: "Post",
      data: data,
    }).then((response) => {
      setOpen(false);
        SBNotify({ Msg: "Fee Saved Successfully", type: "success" });
       getFees();
       
       
    }).catch((error) => {
      SBNotify({ Msg: "some error  occured", type: "error" });
    });
  }
}
  return (
    <>
      <SBADrawer open={open} setOpen={setOpen} style={{ width: "70vw" }} title={"Add New Internal Fee"} >
      {(IsFee &&
       <div className="row">
        <div className="col-md-6">
              <label className="label">
                Billing Name
                <span className="mandatory">*</span>
              </label>
                                                
              <div>
                <SBAComboBox
                  className="w-100"
                  data={billingData}
                  textField={"ClientBillingName"}
                  valueField={"ClientBillingId"}
                  onChange={clientBillingDDChng}
                  popupSettings={{ className: "modalDD" }}
                  value={selectedClientbilling}
                 
                />

              </div>
            </div>
            </div>
            )}
        <div className="row">
      
          <div className="col-md-6">
            <div >
              <label className="label">Portfolio
              <span className="mandatory">*</span>
              </label>

              <SBADropDown
                className="w-100"
                data={activePortfolios}
                textField={"ActivePortfolioName"}
                valueField={"ActivePortfolioId"}
                value={selectedPortfolio}
                onChange={handleSelectedPortfolio}
                popupSettings={{ className: "modalDD" }}
              ></SBADropDown>
            </div>
          </div>
          <div className="col-md-6">
            <div >
              <label className="label">Asset
              <span className="mandatory">*</span>
              </label>
              <SBADropDown
                className="w-100"
                data={assets}
                textField={"AssetName"}
                valueField={"AssetId"}
                value={selectedAsset}
                onChange={handleSelectedAsset}
                popupSettings={{ className: "modalDD" }}
              ></SBADropDown>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-6">
            <div >
              <label className="label">Share Class</label>
              <SBADropDown
                className="w-100"
                data={shareClass}
                textField={"ShareClassName"}
                valueField={"ShareClassId"}
                value={selectedShareClass}
                onChange={handleSelectedShareClass}
                popupSettings={{ className: "modalDD" }}
              ></SBADropDown>
            </div>
          </div>
          <div className="col-md-6">

            <label className="label" >Management Fee</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                className="w-125 input-default form-control"
                type="text"
                Value={mgmtFee ? (mgmtFee.toFixed(2)).toString() : 0.00}
                style={{ marginRight: '5px' }}
                onChange={(e) => { setMgmtFee(Number(e.target.value)) }}
              /><span>%</span>
            </div>
          </div>
        </div>
        {(IsBillable &&
        <div className="row mt-4">
           <div class="col-sm-4">
                <div className="mb-2" ><input type="checkbox" checked={true} disabled={true}/> Advised Billable
                </div>
                </div>
        
        </div>
        )}
        <div className="m-1 d-flex justify-content-end mt-4">
          <button className="s-sm-btn mx-1" onClick={() => { setOpen(false) }}>Cancel</button>
          {(!IsFee? 
          <button className="p-sm-btn mx-1" onClick={handleAddNew}>Add</button>
          : <button className="p-sm-btn mx-1" onClick={saveInternalFee}>Save</button>)}
        </div>
      </SBADrawer>
    </>
  );
};

export const EditInternalFee = ({ open, setOpen, handleSBAFeedata,handlefeedata, rowData, rowId,IsFee,mgmtFeeId }) => {
 
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [shareClass, setShareClass] = useState([]);
  const [selectedShareClass, setSelectedShareClass] = useState(null);
  const [mgmtFee, setMgmtFee] = useState(0.00);
  const [billingData,setbillingData]=useState([]);
  const [selectedClientbilling,setselectedClientbilling]=useState([]);
  useEffect(() => {
    const setData = () => {
      if(!IsFee )
      {
      for (const item of rowData) {
        if (item.rowId === rowId) {
          setSelectedRowData(item);
          setMgmtFee(item.ManagementFee)
          break;
        }
      }
    }
    else
    {
      getFees(mgmtFeeId);
    }
    }
    setData()
  }, [rowData, rowId])

  useEffect(() => {
    getClientBilling();
    const fetchShareClass = async () => {
      const id = !IsFee? selectedRowData?.selectedAsset?.AssetId:selectedRowData?.AssetId
      try {
        const list = await sbaAxios({
          url: getAssetShareClassddl + `${id},${true}`
        })
        setShareClass(list);
        setSelectedShareClass(selectedRowData?.selectedShareClass)
      }
      catch (e) {
        setShareClass([]);
      }
    }
    if (selectedRowData) {
      fetchShareClass();
    }
  }, [selectedRowData])

  const handleSelectedShareClass = (e) => {
    setSelectedShareClass(e.value);
  }
  const getFees = async (mgmtfeeId) => {
  
    try {
      const response = await sbaAxios({
        url: `${getClientMgmtFee}`,
        method: 'get',
    });
if(mgmtfeeId!=null)
{
      
     const dt=response.filter(item => item.ClientMgmtFeeId ===mgmtfeeId);
     if (dt.length > 0) {
      const shcl = {
          ShareClassId: dt[0].ShareClassId,
          ShareClassName: dt[0].ShareClassName
      };
  
      setSelectedRowData({
          ...dt[0],
          selectedShareClass: shcl
      });
      
  }
        setselectedClientbilling({ClientBillingId:dt[0].ClientBillingId,ClientBillingName:dt[0].ClientBillingName});
        setMgmtFee(dt[0].FeeValue);
}
else
{
        handlefeedata(response);
}
    } catch (error) {
        console.error("Error fetching get billing data from API:", error);
    }
};
  const handleEdit = () => {
 if(!IsFee)
 {
    const data = {
      ...selectedRowData,
      ShareClassName: selectedShareClass?.ShareClassName,
      ManagementFee: Number((mgmtFee).toFixed(2)),
      selectedShareClass: selectedShareClass
    }
    const updatedData = rowData.map(row =>
      row.rowId === rowId ? { ...row, ...data } : row
    );
    handleSBAFeedata(updatedData)
    setOpen(false);
 }
 else
 {
  updateInternalFee();
 }
  }

  const updateInternalFee= async()=>
  {
    
    let ifsave = true;
    
    if (selectedClientbilling.length===0) {
      ifsave = false;
      SBNotify({ Msg: "Please Select Client Billing", type: "error" });
    }
   
    else if (selectedRowData.PortfolioId===0) {
      ifsave = false;
      SBNotify({ Msg: "Please Select Portfolio", type: "error" });
    }
  
      if (ifsave) {
          const data = {
              "clientMgmtFeeId": mgmtFeeId,
              "clientBillingId": selectedClientbilling.ClientBillingId,
              "clientBillingName": "string",
              "accountId": 0,
              "portfolioId": selectedRowData.PortfolioId,
              "portfolioName": "string",
              "assetId": selectedRowData.AssetId,
              "assetName": "string",
              "shareClassId": selectedShareClass === null || selectedShareClass === undefined ? 0 : selectedShareClass.ShareClassId,
              "shareClassName": "string",
              "feeValueTypeId": 0,
              "feeValue": mgmtFee,
              "isUpdateBillable": true,
              "createdDate": "2024-10-07T09:07:59.002Z",
              "createdBy": 0,
              "userId": 0,
              "modifiedBy": "string",
              "modifiedDate": "2024-10-07T09:07:59.002Z",
              "recordsType": "string"
          }
      sbaAxios({
        url: `${insertorupdateFee}`,
        method: "Post",
        data: data,
      }).then((response) => {
        setOpen(false);
          SBNotify({ Msg: "Fee Updated Successfully", type: "success" });
          getFees(null);
         
         
      }).catch((error) => {
        SBNotify({ Msg: "some error  occured", type: "error" });
      });
    }
  }
  const getClientBilling = async () => {
    try {

        const response = await sbaAxios({
            url: `${getBillingGetExistingClientsAPI}`,
            method: 'get',
        });
        setbillingData(response)
       
       
    } catch (error) {
        console.error("Error fetching get billing data from API:", error);
    }
};

const clientBillingDDChng = (e) => 
{    
 if (e.value) {
     setselectedClientbilling({ClientBillingId:e.value.ClientBillingId,ClientBillingName:e.value.ClientBillingName});
 }
};
  return (
    <>
      <SBADrawer open={open} setOpen={setOpen} style={{ width: "70vw" }} title={"Update Internal Fee"} >
      {(IsFee &&
       <div className="row">
        <div className="col-md-6">
              <label className="label">
                Billing Name
                <span className="mandatory">*</span>
              </label>
                                                
              <div>
                <SBAComboBox
                  className="w-100"
                  data={billingData}
                  textField={"ClientBillingName"}
                  valueField={"ClientBillingId"}
                  onChange={clientBillingDDChng}
                  popupSettings={{ className: "modalDD" }}
                  value={selectedClientbilling}
                 
                />

              </div>
            </div>
            </div>
            )}
        <div className="row">
         
    
          <div className="col-md-6">
            <div >
              <label className="label">Portfolio</label>
              <input
                className="w-125 input-default form-control"
                type="text"
                Value={selectedRowData?.PortfolioName}
                style={{ marginRight: '5px' }}
                readOnly
              />
            </div>
          </div>
          <div className="col-md-6">
            <div >
              <label className="label">Asset</label>
              <input
                className="w-125 input-default form-control"
                type="text"
                Value={selectedRowData?.AssetName}
                style={{ marginRight: '5px' }}
                readOnly
              />
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-6">
            <div >
              <label className="label">Share Class</label>
              <SBADropDown
                className="w-100"
                data={shareClass}
                textField={"ShareClassName"}
                valueField={"ShareClassId"}
                value={selectedShareClass}
                onChange={handleSelectedShareClass}
                popupSettings={{ className: "modalDD" }}
              ></SBADropDown>
            </div>
          </div>
          <div className="col-md-6">

            <label className="label" >Management Fee</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                className="w-125 input-default form-control"
                type="text"
                Value={mgmtFee}
                style={{ marginRight: '5px' }}
                onChange={(e) => { setMgmtFee(Number(e.target.value)) }}
              /><span>%</span>
            </div>
          </div>
        </div>
        <div className="m-1 d-flex justify-content-end mt-4">
          <button className="s-sm-btn mx-1" onClick={() => { setOpen(false) }}>Cancel</button>
          <button className="p-sm-btn mx-1" onClick={handleEdit}>Update</button>
        </div>
      </SBADrawer>
    </>
  );
};

const defaultColumnDef = {
  flex: 1,
  minWidth: 100,
  resizable: true,
  enableValue: true,
  enableRowGroup: true,
  sortable: true,
  autoHeaderHeight: true
};